'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var agencies = ['Ace', 'Advantage', 'Airport Van', 'Alamo', 'Atwest', 'Avis', 'Black & White Rent A Car', 'Budget', 'Dollar', 'Enterprise', 'E-Z Rent-A-Car', 'Fox', 'Hertz', 'Midway', 'National', 'NU Car', 'Payless', 'Priceless', 'Renty', 'Silvercar', 'Sixt', 'State Van Rental', 'Super Cheap', 'Surprise Agency', 'Thrifty', 'U-Save', 'Yesaway', 'Other'];
exports.default = agencies;